import { render, staticRenderFns } from "./Register.vue?vue&type=template&id=4b4647cc&scoped=true"
import script from "./Register.vue?vue&type=script&lang=js"
export * from "./Register.vue?vue&type=script&lang=js"
import style0 from "./Register.vue?vue&type=style&index=0&id=4b4647cc&prod&lang=scss&scoped=true"
import style1 from "./Register.vue?vue&type=style&index=1&id=4b4647cc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b4647cc",
  null
  
)

export default component.exports